import { gql } from '@apollo/client';

export const CRM_AUTOMATION_FIELDS = `
    _id
    name
    audienceType
    trigger {
        event
        toStageKey
        formId
        sinceDays
        toStatus
        fromStatus
        audienceId
        tagDirection
        meetingTypeId
        meetingTypeIds
    }
    conditions {
        stageKeys
        tags
        leadSources
        ownerIds
        businessStatuses
        currentSystems
        excludeStageKeys
        excludeTags
        excludeLeadSources
        excludeOwnerIds
        excludeBusinessStatuses
        excludeCurrentSystems
        onboardingQuestionnaireStatuses
        onboardingManualStatuses
        accountVerificationStatuses
        onboardingProgress {
            operator
            value
        }
        lastSignIn {
            operator
            value
        }
    }
    steps {
        stepType
        delayDays
        emailSubject
        emailBodyHtml
        emailTemplateId
        smsBody
        taskTitle
        taskDescription
        taskDueInDays
        taskOwnerId
        notifySubject
        notifyBody
        tagKey
        recipientScope
        recipientTagKey
        targetPipelineId
        targetStageKey
        condition {
            type
            tagKey
            stageKeys
            field
            value
            businessStatuses
            onboardingQuestionnaireStatuses
            onboardingManualStatuses
            accountVerificationStatuses
            onboardingProgress {
                operator
                value
            }
            lastSignIn {
                operator
                value
            }
        }
        thenSkipCount
        elseSkipCount
    }
    runOncePerAccount
    status
    pipelineId
    stageKey
    order
    createdAt
    updatedAt
`;

export const LIST_CRM_AUTOMATIONS = gql`
    query ListCrmAutomations {
        listCrmAutomations {
            ${CRM_AUTOMATION_FIELDS}
        }
    }
`;

export const GET_CRM_AUTOMATION = gql`
    query GetCrmAutomation($id: String!) {
        getCrmAutomation(id: $id) {
            ${CRM_AUTOMATION_FIELDS}
        }
    }
`;

// POGO-13862 Phase 5 (H2): per-automation email stats for the Reporting →
// Communication reports → Marketing reports surface. Raw counters only; open/
// click rates are computed on read in the shared stat-column layout (POGO-13850
// parity), alongside the campaign stats.
export const CRM_AUTOMATION_STATS = gql`
    query CrmAutomationStats {
        crmAutomationStats {
            automationId
            name
            status
            totals {
                recipients
                sent
                delivered
                opened
                clicked
                bounced
                failed
                skipped
            }
            steps {
                stepIndex
                title
                stepType
                templateName
                recipients
                sent
                delivered
                opened
                clicked
                bounced
                failed
                skipped
            }
        }
    }
`;
